import axios from './axiosInstances/axiosInstance';

export const applyReferralToBasket = (basketId, body) => {
  return axios.put(`/baskets/${basketId}/referral`, body);
};
